module.exports = __webpack_public_path__ + "img/step-4.6d08ab4d.jpg";